(function () {
    'use strict';

    angular.module("imApp").factory("timeRegisterService", ['$ihttp', 'p2DataTaskService', function ($ihttp, p2DataTaskService) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1345,
                    parameters: parms || {}
                });
            },
            loadTimeRegisterLabourList: function (businessco_no) {
                return p2DataTaskService.call(1531, {
                    businessco_no: businessco_no
                });
            },
            listOperations: function (parms) {
                return $ihttp.post({
                    method: 14,
                    parameters: parms || {}
                });
            },
            listPercentages: function (parms) {
                return $ihttp.post({
                    method: 34,
                    parameters: parms || {}
                });
            },
            listCustacts: function (parms) {
                return $ihttp.post({
                    method: 2726,
                    parameters: parms || {}
                });
            },
            listExtraPowTimes: function (parms) {
                return $ihttp.post({
                    method: 3423,
                    parameters: parms || {}
                });
            },
            getBreakMinutes: function (edit) {
                return $ihttp.post({
                    method: 32,
                    parameters: edit
                });
            },
            getSalaryHoursToTimeAccount: function (edit) {
                return $ihttp.post({
                    method: 3445,
                    parameters: edit
                });
            },
            getPrice: function (edit) {
                return $ihttp.post({
                    method: 35,
                    parameters: edit
                });
            },
            getEquipmentProduct: function (edit) {
                return $ihttp.post({
                    method: 33,
                    parameters: edit
                });
            },
            changeCustact: function (parms) {
                return $ihttp.post({
                    method: 2725,
                    parameters: parms
                });
            },
            changeColumn: function (edit) {
                return $ihttp.post({
                    method: 4013,
                    parameters: edit
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 36,
                    parameters: edit
                });
            },
            approve: function (edit) {
                return $ihttp.post({
                    method: 1346,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 1522,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
